'use strict';
require('jquery');

import { queryString } from './params';
import { initTabs } from './tabs';

$(document).ready(() => {
  initTabs('.publi-tab-btn', '.publi-panel', {
    containerId: 'publi-container',
    showAllClass: 'publi-show-all',
  });

  if ('author' in queryString) {
    // Author filter hides non-matching publications and empty year sections.
    const author = queryString['author'];
    const authorClass = `publi_${author}`;

    const $items = $('div.publication');
    const $matching = $items.filter(function () {
      return this.classList.contains(authorClass);
    });

    if ($matching.length === 0) {
      $('#publi-container').prepend(
        '<div class="notice notice--info">No publications found for this author.</div>'
      );
      return;
    }

    $items.not($matching).hide();

    $('.publi-panel').each(function () {
      const $panel = $(this);
      if ($panel.find('.publication:visible').length === 0) {
        $panel.find('.publication_year').hide();
      }
    });

    // If the tab shown by default has no matches for this author, jump to
    // the first (most recent) year that does.
    const $activePanel = $('.publi-panel.is-active');
    if ($activePanel.find('.publication:visible').length === 0) {
      const targetId = $matching.first().closest('.publi-panel').attr('id');
      document.querySelector(`.publi-tab-btn[data-tab="${targetId}"]`)?.click();
    }
  }
});
